import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
    </header>
  );
};

export default Header;
